import React from "react";
import axios from 'axios';
import { dispatchAiCreditAlert } from "./aiCreditAlerts";

const DEFAULT_API_PORT_HTTP = '8101';
const DEFAULT_API_PORT_HTTPS = '8443';
const SHOULD_USE_LOCAL_API = process.env.REACT_APP_USE_LOCAL_API === 'true';
/* API TABANI.
 *
 * UYARI: `PUBLIC_BASE_URL` burada ETKISIZ. CRA derlemede yalniz `REACT_APP_`
 * ile baslayan degiskenleri (ve NODE_ENV/PUBLIC_URL) tarayici paketine gomer;
 * digerleri `undefined` kalir. Yani deploy'da PUBLIC_BASE_URL vermek hicbir
 * sey degistirmez — adres degistirilecekse `REACT_APP_API_URL` ayarlanmali.
 * Satir geriye donuk uyum icin duruyor.
 *
 * Ayrica: buraya panelin SERVIS EDILDIGI adres (ornegin https://chatpilots.ai)
 * yazilirsa her API cagrisi statik siteye gider ve HTML doner; giris "calismaz"
 * ama sebebi gorunmez. Buraya API'nin adresi yazilir. */
const REMOTE_API_BASE =
  process.env.REACT_APP_API_URL ||
  process.env.PUBLIC_BASE_URL ||
  '';
const DEFAULT_API_PROTOCOL =
  typeof window !== 'undefined' && window.location && window.location.protocol
    ? window.location.protocol
    : 'https:';
const DEFAULT_API_HOST =
  SHOULD_USE_LOCAL_API &&
  typeof window !== 'undefined' &&
  window.location &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname)
    ? window.location.hostname
    : 'cyberistanbul.com';

const buildApiUrl = () => {
  if (
    SHOULD_USE_LOCAL_API &&
    typeof window !== 'undefined' &&
    window.location &&
    ['localhost', '127.0.0.1'].includes(window.location.hostname)
  ) {
    const protocol = DEFAULT_API_PROTOCOL.endsWith(':')
      ? DEFAULT_API_PROTOCOL
      : `${DEFAULT_API_PROTOCOL}:`;
    const port = protocol === 'https:' ? DEFAULT_API_PORT_HTTPS : DEFAULT_API_PORT_HTTP;
    return `${protocol}//${window.location.hostname}:${port}/`;
  }

  if (REMOTE_API_BASE) {
    return String(REMOTE_API_BASE).replace(/\/?$/, "/");
  }

  const protocol = 'https:';
  const port = DEFAULT_API_PORT_HTTPS;
  return `${protocol}//${DEFAULT_API_HOST}:${port}/`;
};

export const apiUrl = buildApiUrl();

const instance = axios.create({
  baseURL: apiUrl,
  headers: { 'Content-Type': 'application/json' }
});

const parseStoredToken = (raw) => {
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (_error) {
    return raw;
  }
};

instance.interceptors.request.use((config) => {
  const rawSession =
    typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('token') : null;
  const raw = rawSession !== null ? rawSession : localStorage.getItem('token');
  const token = parseStoredToken(raw);
  if (token) config.headers.Authorization = `Bearer ${token}`;

  /* MİSAFİR KAPISI KALDIRILDI. Ziyaretçi artık sunucuda gerçek (ama geçici)
     bir hesapla geziyor: kendi tenantı, kendi verisi, ücretsiz planın kredisi.
     İstekleri kesmeye gerek yok — sınırı plan/kredi koyuyor. */
  return config;
});

/* PLAN KAPISI UYARISI (v2): sunucu 403 { upgrade_required } döndüğünde
   sayfalar ham hata yerine tek tip yükseltme uyarısı gösterir (10 sn'de bir). */
let sonYukseltmeUyarisi = 0;
const yukseltmeUyarisi = (error) => {
  try {
    const d = error && error.response && error.response.data;
    if (!d || !d.upgrade_required) return;
    if (Date.now() - sonYukseltmeUyarisi < 10000) return;
    sonYukseltmeUyarisi = Date.now();
    const { message } = require("antd");
    const lang = (typeof window !== "undefined" && window.localStorage && window.localStorage.getItem("landingLang")) || "tr";
    const metin = lang === "tr" ? (d.message || "Bu özellik Growth ve Enterprise planlarda açık.") : "This feature is available on Growth and Enterprise plans.";
    const link = lang === "tr" ? "Planı yükselt" : "Upgrade plan";
    message.warning({
      content: React.createElement("span", null, metin + " ", React.createElement("a", { href: "/plan?why=" + encodeURIComponent(d.feature || "") }, link)),
      duration: 6,
    });
  } catch (_e) { /* uyarı gösterilemezse sessiz */ }
};

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    dispatchAiCreditAlert(error, { source: "axios" });
    yukseltmeUyarisi(error);
    return Promise.reject(error);
  }
);

/**
 * İSTEMCİ ÜRETİMLİ KOMUT KİMLİĞİ (bulgu A1).
 *
 * NEDEN: akışlı yol ile düz yedek yol AYNI komutu iki kez koşturabiliyordu
 * (akış koptu → düz yola düşüldü → sunucuda ikinci randevu, ikinci gelir
 * kaydı, ikinci kredi kesintisi). Bu kimlik her iki istekte de aynı gider;
 * sunucu aynı tenant+komutId'yi 60 sn içinde ikinci kez görürse işi
 * KOŞMADAN ilk koşumun cevabını döner.
 * `crypto.randomUUID` yoksa (eski tarayıcı, güvensiz kaynak) zaman+rastgele
 * yedeği kullanılır: kimliğin evrensel benzersiz olması gerekmiyor, aynı
 * tenant'ta 60 saniye içinde çakışmaması yetiyor.
 */
export function komutKimligiUret() {
  try {
    if (typeof crypto !== "undefined" && crypto && typeof crypto.randomUUID === "function") return crypto.randomUUID();
  } catch (e) { console.warn("[komut kimliği] randomUUID kullanılamadı, yedek üretiliyor:", e && e.message); }
  return "k" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
}

/**
 * AKIŞ KOPTU HATASI — düz yola DÜŞÜLMEZ (bulgu A1/A2).
 * `akisAcildi` bayrağını çağıran ekran okuyup dürüst cümleyi gösterir:
 * komut sunucuda çalışmış OLABİLİR, "hiçbir kayıt oluşmadı" demek yalan olur.
 */
function akisKoptuHatasi(zamanAsimiMi) {
  const hata = new Error(zamanAsimiMi ? "komut akışı zaman aşımı" : "komut akışı koptu");
  hata.akisAcildi = true;
  hata.akisZamanAsimi = Boolean(zamanAsimiMi);
  return hata;
}

/**
 * AKIŞLI KOMUT (bulgu 5) — sunucu-gönderimli olay akışı (SSE) okur.
 *
 * NEDEN: /command tek bloklu JSON döndürüyordu ve sahip 2,0-7,5 saniye
 * (ölçüm: "Bugünkü randevuları listele" 7,46 sn) BOŞ ekrana bakıyordu.
 * Sunucu artık ne yaptığını adım adım söylüyor; burası o adımları okuyup
 * `onAdim`e veriyor.
 *
 * AKIŞ DESTEKLENMİYORSA ESKİ DAVRANIŞA DÜŞER: fetch/ReadableStream yoksa,
 * uç 404 dönerse ya da ara sunucu akışı kesip düz JSON verirse `null` döner
 * ve çağıran normal axios.post yolunu kullanır. Hata YUTULMAZ: sebep konsola
 * yazılır, yoksa "akış neden çalışmıyor" hiç görülemez.
 *
 * @param {string} yol   akış ucu (ör. "/api/ai-copilot/command/stream")
 * @param {object} govde istek gövdesi (/command ile birebir aynı)
 * @param {function} onAdim (metin, faz) → şerit güncellemesi
 * @returns {Promise<object|null>} /command'ın `data` gövdesi ya da null (düş)
 * @throws {Error} akış AÇILDIKTAN sonra koptuysa (`akisAcildi`) — bu durumda
 *   çağıran düz yola DÜŞMEZ: komut sunucuda zaten koşmuş olabilir.
 */
export async function komutuAkisliGonder(yol, govde, onAdim) {
  if (typeof fetch !== "function" || typeof ReadableStream === "undefined") return null;
  /* SÜRE SINIRI AKIŞ TARAFINDA OLMALI (bulgu A2). Eski TEK yol
     `axios.post(..., { timeout: 90000 })` idi ve yorumu nedenini yazıyordu:
     "sunucu takılınca ekran sonsuza dek çalışıyorum'da kalıyordu". Akış
     birincil yol olunca o timeout ULAŞILMAYAN yedek çağrıda kaldı; burada
     hiçbir sınır yoktu — sunucu ilk çerçeveden sonra susarsa `read()`
     sonsuza dek bekliyor, şerit "hazırlıyorum"da donuyordu (mobil bunu
     xhr.timeout ile doğru yapıyordu: aynı iş, iki davranış).
     İKİ SAYAÇ: toplam 90 sn tavan (komut turu bu kadar sürebilir) ve
     çerçeve başına sıfırlanan 30 sn ATIL süre — sunucu adım yolladığı
     sürece uzun iş kesilmez, sustuğu an kesilir. */
  const durdurucu = typeof AbortController === "function" ? new AbortController() : null;
  let zamanAsimi = false;
  let atilSayac = null;
  const toplamSayac = durdurucu ? setTimeout(() => { zamanAsimi = true; durdurucu.abort(); }, 90000) : null;
  const atilSifirla = () => {
    if (!durdurucu) return;
    if (atilSayac) clearTimeout(atilSayac);
    atilSayac = setTimeout(() => { zamanAsimi = true; durdurucu.abort(); }, 30000);
  };
  const sayaclariBirak = () => {
    if (toplamSayac) clearTimeout(toplamSayac);
    if (atilSayac) clearTimeout(atilSayac);
  };
  /* AKIŞ AÇILDI MI? `basladi` çerçevesi geldiyse komut SUNUCUDA ÇALIŞMAYA
     BAŞLAMIŞTIR. Bundan sonra düz yola düşmek komutu İKİNCİ KEZ koşturur
     (iki randevu, iki gelir kaydı, iki kez kredi) — bu yüzden düşmek yerine
     dürüst cümle döner. Sunucudaki komutId önbelleği ikinci koşumu zaten
     durdurur; bu bayrak kullanıcıya DOĞRU cümleyi söylemek içindir. */
  let acildi = false;
  let token = null;
  try {
    const rawSession = typeof sessionStorage !== "undefined" ? sessionStorage.getItem("token") : null;
    token = parseStoredToken(rawSession !== null ? rawSession : localStorage.getItem("token"));
  } catch (_e) { token = null; }
  let yanit;
  atilSifirla();
  try {
    yanit = await fetch(String(apiUrl).replace(/\/$/, "") + yol, {
      method: "POST",
      headers: Object.assign({ "Content-Type": "application/json" }, token ? { Authorization: `Bearer ${token}` } : {}),
      body: JSON.stringify(govde || {}),
      signal: durdurucu ? durdurucu.signal : undefined,
    });
  } catch (e) {
    sayaclariBirak();
    console.warn("[komut akışı] açılamadı, düz yola düşülüyor:", e && e.message);
    /* Buraya kadar tek bayt gelmedi: komut sunucuda başlamadı, düz yol
       GÜVENLE koşabilir. */
    return null;
  }
  if (!yanit || !yanit.ok || !yanit.body || typeof yanit.body.getReader !== "function") {
    sayaclariBirak();
    console.warn("[komut akışı] uç akış vermedi (durum " + (yanit && yanit.status) + "), düz yola düşülüyor");
    return null;
  }
  const okuyucu = yanit.body.getReader();
  const cozucu = new TextDecoder("utf-8");
  let tampon = "";
  let sonuc = null;
  try {
    for (;;) {
      const { value, done } = await okuyucu.read();
      if (done) break;
      atilSifirla(); // veri geldi: sunucu susmuş değil
      tampon += cozucu.decode(value, { stream: true });
      /* Çerçeveler boş satırla ayrılır; yarım kalan son parça tamponda kalır. */
      let sinir = tampon.indexOf("\n\n");
      while (sinir >= 0) {
        const blok = tampon.slice(0, sinir);
        tampon = tampon.slice(sinir + 2);
        sinir = tampon.indexOf("\n\n");
        const olay = (blok.match(/^event: (.+)$/m) || [])[1] || null;
        const ham = (blok.match(/^data: ([\s\S]+)$/m) || [])[1] || null;
        if (!olay || !ham) continue;
        let veri = null;
        try { veri = JSON.parse(ham); } catch (_e) { continue; }
        if (olay === "basladi") acildi = true;
        if (olay === "adim" && typeof onAdim === "function" && veri && veri.metin) onAdim(veri.metin, veri.faz);
        if (olay === "sonuc") sonuc = veri;
      }
    }
  } catch (e) {
    sayaclariBirak();
    console.warn("[komut akışı] okuma kesildi:", e && e.message);
    if (sonuc && sonuc.data) return sonuc.data;
    if (acildi) throw akisKoptuHatasi(zamanAsimi);
    return null;
  }
  sayaclariBirak();
  if (!sonuc) {
    if (acildi) {
      /* Akış açıldı ama sonuç gelmedi: komut sunucuda koşmuş olabilir.
         Eskiden burada `null` dönülüp düz yola düşülüyordu — mükerrer
         koşumun ta kendisi. */
      console.warn("[komut akışı] açılmıştı ama sonuç çerçevesi gelmedi — düz yola DÜŞÜLMÜYOR");
      throw akisKoptuHatasi(zamanAsimi);
    }
    console.warn("[komut akışı] sonuç çerçevesi gelmedi, düz yola düşülüyor");
    return null;
  }
  /* Sunucu hata çerçevesi yolladıysa çağıran bunu AXIOS HATASI GİBİ görsün.
     `response` ŞART: çağıran ekranlar durum kodu yoksa "sunucuya ulaşamadım,
     hiçbir kayıt oluşmadı" diyor — oysa istek sunucuya ULAŞTI ve komut kısmen
     çalışmış olabilir. Yanlış güvence vermektense gerçek durumu taşı. */
  if (sonuc.error) {
    const hata = new Error(sonuc.message || "komut işlenemedi");
    hata.akisHatasi = true;
    hata.response = { status: sonuc.status || 500, data: { error: 1, message: sonuc.message || "komut işlenemedi" } };
    throw hata;
  }
  return sonuc.data || {};
}

export default instance;
